import React from "react";
import { AttentionDays } from "../components/attentionday/AttentionDays";

export function AttentionDaysView() {
    return (
        <div className="view view-attentiondays">
            <AttentionDays />
        </div>
    );
}
